import React, { useState, useEffect, useRef } from 'react';
import JessibucaPlayer from '@/components/JessibucaPlayer';
import styles from './style.less';
import classnames from 'classnames';
import { useRequest, request, useLocation } from 'umi';
import { useUpdateEffect } from 'ahooks';
import {
  CaretUpOutlined,
  CaretRightOutlined,
  CaretDownOutlined,
  CaretLeftOutlined,
} from '@ant-design/icons';
import { message, Tag, Modal } from 'antd';
import 'recorder-core/recorder.mp3.min';
import RecordApp from 'recorder-core/src/app-support/app';
import WebRTCComponent from '@/components/JFWebRTCTalk';
import { startsWithExcludedString } from '@/util';

let apiPrefix = 'https://open.mokan.cn';
let startRecording = false;

const Live = () => {
  const location = useLocation();
  let {
    type,
    deviceId,
    serialNumber,
    timestamp,
    clientCode,
    sign,
    hideYun,
    hideVoiceBtn,
    text1,
    text2,
    text3,
    talkback,
    setPresetPosition, //预置位
  } = location.query;

  const playerRef = useRef();
  const [active, setActive] = useState(false);
  const [isMute, setIsMute] = useState(true);
  const [isHD, setIsHD] = useState(false);
  const [url, setUrl] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const [showTag, setShowTag] = useState(false); // 有无预置位
  const hasYzw = setPresetPosition && setPresetPosition != 'false';
  const [deviceInfo, setDeviceInfo] = useState(null); //设备信息

  useUpdateEffect(() => {
    if (playerRef.current) {
      if (active) {
        playerRef.current.setRotate(270);
      } else {
        playerRef.current.setRotate(0);
      }
      playerRef.current.resize();
    }
  }, [active]);

  if (type === 'test') {
    apiPrefix = 'https://test-open.mokan.cn';
  }

  const tempObj = {};
  if (serialNumber) {
    tempObj.serialNumber = serialNumber;
  } else if (deviceId) {
    tempObj.deviceId = deviceId;
  }
  useEffect(() => {
    hasYzw &&
      _getYzw().then((res) => {
        setShowTag(!res.data);
      });
  }, []);
  useEffect(() => {
    if (url) {
      getDeviceInfo().then((res) => {
        setDeviceInfo(res.data);
      });
    }
  }, [url]);
  function getDeviceInfo() {
    return request(`${apiPrefix}/openapi/ai/getDeviceInfo`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }
  //杰峰设备保活
  function _JFdeviceLogin(params) {
    return request(`${apiPrefix}/openapi/video/deviceLogin`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params,
    });
  }
  function _JFdeviceKeepAlive(params) {
    return request(`${apiPrefix}/openapi/video/deviceKeepAlive`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params,
    });
  }
  //杰峰的设备，保活逻辑，每隔20秒调用一次
  useEffect(() => {
    let intervalId;

    const handleDeviceLogin = async () => {
      try {
        await _JFdeviceLogin({ serialNumber: deviceInfo.serialNumber });
        // 登录成功后，设置定时器每隔20秒调用_JFdeviceKeepAlive
        intervalId = setInterval(() => {
          _JFdeviceKeepAlive({ serialNumber: deviceInfo.serialNumber });
        }, 20000);
      } catch (error) {
        // console.error('设备登录失败:', error);
      }
    };

    if (deviceInfo && startsWithExcludedString(deviceInfo?.deviceType)) {
      handleDeviceLogin();
    }

    // 清除定时器
    return () => {
      clearInterval(intervalId);
    };
  }, [deviceInfo]);
  const _startStream = ({ voice, resolution }) => {
    if (!tempObj.deviceId && !tempObj.serialNumber) {
      return message.error('参数缺失');
    }
    return request(`${apiPrefix}/openapi/video/startStream`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: {
        ...tempObj,
        force: true,
        voice,
        resolution,
      },
    });
  };

  const _mqtt = (cmd) => {
    return request(`${apiPrefix}/openapi/video/cloudDeckControl`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      data: {
        ...tempObj,
        cmd,
      },
    });
  };

  const { data, loading } = useRequest(
    () => {
      return _startStream({
        voice: true,
        resolution: 0,
      });
    },
    {
      onSuccess(response) {
        setUrl(response.data.flvs);
      },
    },
  );
  // const [msgss, setmsg] = useState([111111111111111])
  const recReq = () => {
    RecordApp.RequestPermission(
      () => {
        startRecording = true;
        setIsRecording(true);
        recStart();
        // console.info("已获得录音权限，可以开始录音了", 2);
        // setmsg([...msgss, '已获得录音权限，可以开始录音了']);
      },
      (msg, isUserNotAllow) => {
        // setmsg([...msgss, `123${msg}`]);
        // if (isUserNotAllow) {//用户拒绝了录音权限
        //   console.info("用户拒绝了录音权限", 2);
        //   setmsg([...msgss, '用户拒绝了录音权限']);
        // }
      },
    );
  };

  const recStart = () => {
    RecordApp.Start(
      {
        // type: 'g711a',
        // sampleRate: 16000,
        // bitRate: 16,
      },
      () => {
        console.info('录音中recStart', 1);
        // setmsg([...msgss, '录音中recStart']);
      },
      (msg) => {
        console.info('开始录音失败：' + msg, 1);
        // setmsg([...msgss, '开始录音失败：']);
      },
    );
  };

  function recStop() {
    if (!startRecording) return;
    // console.info("正在结束录音...");
    // setmsg([...msgss, '正在结束录音']);
    RecordApp.Stop(
      (aBuf, duration, mime) => {
        if (typeof Blob != 'undefined' && typeof window == 'object') {
          var blob = new Blob([aBuf], { type: mime });
          // console.log(blob);
          _playAudioFile({
            file: blob,
          })
            .then(() => {
              message.success('上传成功');
            })
            .catch((err) => {
              message.error('上传失败');
            });
        }
      },
      (msg) => {
        // console.info("结束录音失败：" + msg, 1);
        // setmsg([...msgss, '结束录音失败：']);
      },
    );
    setIsRecording(false);
    startRecording = false;
  }
  function _playAudioFile(data) {
    const objData = new FormData();
    objData.append('deviceId', deviceId || deviceInfo?.id);
    objData.append('file', data.file);
    return request(`${apiPrefix}/openapi/video/playAudioFile`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      data: objData,
    });
  }
  function _setPtz(obj) {
    const objData = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      objData.append(key, value);
    }
    return request(`${apiPrefix}/openapi/video/setDefaultPtz`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      data: objData,
    });
  }
  function _getYzw() {
    return request(`${apiPrefix}/openapi/video/getDefaultPtzStatus`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }
  // 复位
  function _goPlace() {
    return request(`${apiPrefix}/openapi/video/gotoDefaultPlace`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }
  // 操作预置位
  const handleYZW = () => {
    Modal.confirm({
      title: '是否设置预置位，确认后将当前位置设置为预置位？',
      cancelText: '取消',
      okText: '确定',
      centered: true,
      width: 260,
      onOk() {
        var blob = playerRef.current?.screenshot();

        if (blob) {
          let obj = {
            ...tempObj,
            img: blob,
          };
          _setPtz(obj).then(() => {
            message.success('操作成功');
            setShowTag(false);
          });
        } else {
          message.success('请稍后重试');
        }

      },
    });
  };
  if (!data) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div
        onClick={() => {
          setActive(false);
        }}
        className={classnames('exit', {
          active,
        })}
      >
        退出全屏
      </div>
      <div
        className={classnames('player', {
          active,
        })}
      >
        {showTag && (
          <Tag color="blue" className="yzw-tag">
            无预置位
          </Tag>
        )}
        <JessibucaPlayer url={url} ref={playerRef} defaultMute={isMute} />
        <div className={active ? 'fullscreen-projectInfo' : 'projectInfo'}>
          {serialNumber != 'null' && serialNumber != 'undefined' && (
            <div>{serialNumber}</div>
          )}
          {text1 != 'null' && text1 != 'undefined' && <div>{text1}</div>}
          {text2 != 'null' && text2 != 'undefined' && <div>{text2}</div>}
          {text3 != 'null' && text3 != 'undefined' && <div>{text3}</div>}
        </div>
      </div>

      <div
        className={classnames('bar', {
          active,
        })}
      >
        {!hideVoiceBtn && (
          <div className="item">
            {isMute ? (
              <img
                onClick={() => {
                  playerRef.current.cancelMute();
                  setIsMute(false);
                }}
                className="mute"
                src={require('./assets/mute.png')}
                alt=""
              />
            ) : (
              <img
                onClick={() => {
                  playerRef.current.mute();
                  setIsMute(true);
                }}
                className="mute"
                src={require('./assets/voice.png')}
                alt=""
              />
            )}
          </div>
        )}
        <div className="item">
          {isHD ? (
            <img
              className="hd"
              onClick={() => {
                _startStream({
                  voice: true,
                  resolution: 0,
                }).then((response) => {
                  setUrl(response.data.flvs);
                });
                setIsHD(false);
              }}
              src={require('./assets/hd.png')}
              alt=""
            />
          ) : (
            <img
              onClick={() => {
                _startStream({
                  voice: true,
                  resolution: 1,
                }).then((response) => {
                  setUrl(response.data.flvs);
                });
                setIsHD(true);
              }}
              className="hd"
              src={require('./assets/sd.png')}
              alt=""
            />
          )}
        </div>
        <div
          className="item"
          onClick={() => {
            setActive(true);
          }}
        >
          <img
            className="screenfull"
            src={require('./assets/screenfull.png')}
            alt=""
          />
        </div>
      </div>

      {!hideYun && (
        <div className={classnames('mq', { active })}>
          <CaretUpOutlined
            onClick={() => {
              _mqtt('cloud_deck_up');
            }}
            className="icon"
          />

          <div className="center">
            <CaretLeftOutlined
              onClick={() => {
                _mqtt('cloud_deck_left');
              }}
              className="icon"
            />

            <CaretRightOutlined
              onClick={() => {
                _mqtt('cloud_deck_right');
              }}
              className="icon"
            />
          </div>

          <CaretDownOutlined
            onClick={() => {
              _mqtt('cloud_deck_down');
            }}
            className="icon"
          />
        </div>
      )}
      {hasYzw && (
        <div className="yzw-btns">
          <div className="btn-com" onClick={() => handleYZW()}>
            设置预置位
          </div>
          <div
            className="btn-com"
            onClick={() => {
              if (showTag) {
                message.error('设备无预置位，请先设置');
              } else {
                _goPlace().then(() => {
                  message.success('操作成功，正在回到预置位');
                });
              }
            }}
          >
            复位
          </div>
        </div>
      )}
      {!talkback || talkback == 'false' ? (
        ''
      ) : (
        <>
          {startsWithExcludedString(deviceInfo?.deviceType) ? (
            <WebRTCComponent
              serialNumber={serialNumber}
              deviceId={deviceId || deviceInfo?.id}
              timestamp={timestamp}
              clientCode={clientCode}
              sign={sign}
              apiPrefix={apiPrefix}
            />
          ) : (
            <div
              onTouchStart={() => recReq()}
              onTouchEnd={() => recStop()}
              className="btn-com callBtn"
              type="primary"
              onContextMenu={(e) => {
                console.info('onContextMenu');
                e.stopPropagation();
              }}
            >
              <img src={require('@/assets/whitephone.png')} alt="喊话icon" />
              {isRecording ? '松开发送' : '按住喊话'}
            </div>
          )}
        </>
      )}
      {/* {
          msgss.map((ele, i) => <div key = {i} style={{color: 'red'}}>{ele}</div>)
        }  */}
    </div>
  );
};

export default () => {
  return <Live />;
  // if (navigator.userAgent.indexOf('UCBrowser') > -1) {
  //   return (
  //     <NoticeBar theme="danger">
  //       由于UC不支持播放器播放，请使用其他播放器打开当前地址
  //     </NoticeBar>
  //   );
  // } else {
  //   return <Live />;
  // }
};
